import React from 'react';

import { FormikSettingCheckbox } from '../_core/Formik/formik-setting-checkbox.component';
import { IntlMsg } from '../_core/IntlMsg/intl-msg.component';
import { getMessages } from './jersey-assignment.messages';
import { useCompanySportTerminology } from '../../lib/stores/company.store';

interface IRetainJerseyAssignmentsFieldProps {
  // The association sets the default; an assessment overrides it or leaves it unset.
  scope: 'association' | 'assessment';
  fid?: string;
}

export const RetainJerseyAssignmentsField: React.FC<IRetainJerseyAssignmentsFieldProps> = ({ scope, fid }) => {
  const messages = getMessages(useCompanySportTerminology());
  const isAssessment = scope === 'assessment';

  return (
    <FormikSettingCheckbox
      name="retainJerseyAssignments"
      fid={fid}
      triState={isAssessment}
      label={messages.lblRetainJerseyAssignments}
      caption={<IntlMsg {...(isAssessment ? messages.captionRetainAssessment : messages.captionRetainAssociation)} />}
    />
  );
};
